const Style = {
    lede: 'mb-6 mt-3.5 text-base leading-relaxed text-text-secondary md:text-lg',
    list: 'm-0 flex list-none flex-col gap-2.5 p-0',
    item: 'flex gap-2.5 text-sm text-text-secondary',
    check: 'mt-1 flex-none text-primary-600',

    frame: 'overflow-hidden rounded-2xl border border-border bg-background',
    url: 'truncate border-b border-border px-4 py-3 font-mono text-xs text-text-muted',
    screen: 'block w-full h-auto',
};

export default Style;
